(function() { module.exports = window["eventespresso"]["adapters"]; }());